module.exports = function getResource(label) {
    const resources = {
        header: 'Envie de la livraison gratuite?',
        message: 'Ouvrez une session pour profiter de la livraison gratuite pour cet achat.',
        signInText: 'Ouvrir une session'
    };

    return resources[label];
};
